<script setup>
import Slider from '@/components/Slider.vue'
import { useSeoStore } from '~/stores/seo'

const props = defineProps({
  items: {
    type: Array,
    default: () => [],
  },
})

const seoStore = useSeoStore()
</script>

<template>
  <div class="row justify-content-center">
    <div class="col-12 col-800-10 col-1200-8 product-slider">
      <Slider
        :show-pagination="true"
        :wrap-around="true"
        :slides="props.items"
      >
        <template #default="slide">
          <ProductTeaser
            :slide="slide"
            align="center"
            parent-type="category-teaser"
            :parent-title="seoStore.pageTitle"
          />
        </template>
      </Slider>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.product-slider {
  overflow: hidden;
  :deep(.embla__slide) {
    flex: 0 0 83.333%; /* Default slide covers 100% of the viewport */
  }
  @media (min-width: 560px) {
    :deep(.embla__slide) {
      flex: 0 0 62.5%; /* Breakpoint SM slide covers 50% of the viewport */
    }
  }
  @media (min-width: 800px) {
    :deep(.embla__slide) {
      flex: 0 0 45.4545%; /* Breakpoint SM slide covers 50% of the viewport */
    }
  }
  @media (min-width: 1200px) {
    :deep(.embla__slide) {
      flex: 0 0 27.7777%; /* Breakpoint SM slide covers 50% of the viewport */
    }
  }
}
</style>
